import { ContentPage } from "../../types/customization/content";
import { TemplatePageDefinition } from "../../types/customization/template";

export const bookCoverAndSpecials = [
  "front-cover",
  "back-cover",
  "layflat-back-matter",
  "layflat-front-matter",
  "single-back-matter",
  "single-front-matter",
  "spine",
];

export function getCoverDefinitions(
  pageDefinitions: TemplatePageDefinition[]
): TemplatePageDefinition[] {
  return pageDefinitions.filter((definition) => {
    return (
      definition.type === "front-cover" ||
      definition.type === "back-cover" ||
      definition.type === "spine"
    );
  });
}

export function getNoCoverDefinitions(
  pageDefinitions: TemplatePageDefinition[]
): TemplatePageDefinition[] {
  return pageDefinitions.filter((definition) => {
    return bookCoverAndSpecials.includes(definition.type) === false;
  });
}

export function hasCoverDefinition(pageDefinitions: TemplatePageDefinition[]): boolean {
  return !!pageDefinitions.find((definition) => {
    return definition.type === "front-cover";
  });
}

export function getCoverFilteredPages(
  contentPages: ContentPage[],
  coverPageDefinitions: TemplatePageDefinition[]
): ContentPage[] {
  const coverPageDefinitionsKeys = coverPageDefinitions.map((pageDefinition) => {
    return pageDefinition.key;
  });
  return contentPages.filter((page) => {
    return coverPageDefinitionsKeys.includes(page.pageDefinitionKey);
  });
}

export function findCoverTitlePlacement(
  pageDefinitions: TemplatePageDefinition[],
  contentPages: ContentPage[]
): { cover: boolean; spine: boolean; frontMatter: boolean } {
  const displayPlaces = { cover: false, spine: false, frontMatter: false };
  const searchTypes = ["front-cover", "layflat-front-matter", "single-front-matter", "spine"];
  const searchPageDefinitions = pageDefinitions.filter((pageDefinition) => {
    return searchTypes.includes(pageDefinition.type);
  });

  const pageDefinitionsByKey: { [key: string]: TemplatePageDefinition } = {};
  searchPageDefinitions.forEach((pageDefinition) => {
    pageDefinitionsByKey[pageDefinition.key] = pageDefinition;
  });

  contentPages.forEach((page) => {
    const pageDefinition = pageDefinitionsByKey[page.pageDefinitionKey];
    if (!pageDefinition) {
      return;
    }

    const titleDefinition = pageDefinition.elementDefinitions.find((elementDefinition) => {
      return (
        elementDefinition.type === "forced-text" &&
        elementDefinition.forcedType === "interpolated-content" &&
        elementDefinition.interpolatedContent === "book_title"
      );
    });
    if (!titleDefinition) {
      return;
    }
    if (pageDefinition.type === "front-cover") {
      displayPlaces.cover = true;
    }
    if (pageDefinition.type === "spine") {
      displayPlaces.spine = true;
    }
    if (
      pageDefinition.type === "single-front-matter" ||
      pageDefinition.type === "layflat-front-matter"
    ) {
      displayPlaces.frontMatter = true;
    }
  });
  return displayPlaces;
}
